export function getMockPayload(
  mockRequestId: string,
  mockSigid: string,
  mockEvent: string
) {
  // Map old event names to Firma event types
  const eventTypeMap: Record<string, string> = {
    signature_request_viewed: "signing_request.viewed",
    signature_request_signed: "signing_request.recipient.signed",
    signature_request_downloadable: "signing_request.completed",
    signature_request_remind: "signing_request.remind",
  };

  const firmaEventType = eventTypeMap[mockEvent] || mockEvent;

  const timestamp = new Date().toISOString();
  const signedAt = Math.floor(Date.now() / 1000);
  const isViewedEvent = firmaEventType === "signing_request.viewed";
  const isSignedEvent = firmaEventType === "signing_request.recipient.signed";
  const isCompletedEvent = firmaEventType === "signing_request.completed";

  return {
    type: firmaEventType,
    event_id: `evt_${mockRequestId.substring(0, 12)}`,
    timestamp: timestamp,
    data: {
      signing_request: {
        id: mockRequestId,
        status:
          isCompletedEvent
            ? "completed"
            : "pending",
        template_id: "tmpl_mock_template",
        created_at: signedAt,
        finished_date:
          isCompletedEvent
            ? timestamp
            : undefined,
      },
      signing_request_id: mockRequestId,
      recipient: {
        id: mockSigid,
        first_name: "Taneeya",
        last_name: "ConsentTest",
        email: "taneeya@fama.io",
        designation: "Signer",
        order: 1,
        finished_date:
          isCompletedEvent || isSignedEvent
            ? timestamp
            : undefined,
        viewed_at:
          isViewedEvent || isSignedEvent || isCompletedEvent
            ? timestamp
            : undefined,
        signed_at:
          isSignedEvent || isCompletedEvent
            ? signedAt
            : undefined,
      },
      recipients: [
        {
          id: mockSigid,
          first_name: "Taneeya",
          last_name: "ConsentTest",
          email: "taneeya@fama.io",
          designation: "Signer",
          order: 1,
          finished_date:
            isCompletedEvent || isSignedEvent
              ? timestamp
              : undefined,
          viewed_at:
            isViewedEvent || isSignedEvent || isCompletedEvent
              ? timestamp
              : undefined,
          signed_at:
            isSignedEvent || isCompletedEvent
              ? signedAt
              : undefined,
        },
      ],
    },
  };
}
